<template>
  <v-container id="notificaciones" tag="section">
    <base-v-component heading="Respuestas de la notificación " />
    <base-material-card color="indigo" icon="mdi-bell-ring" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="respuestasTable"
        :loading="loading"
        :search="search"
        sort-by="rest"
        :sort-desc="true"
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="verRespuestasRestaurante(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  color="info"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-book</v-icon>
                </v-btn>
              </template>
              <span>Ver respuestas</span>
            </v-tooltip>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog v-model="dialogoRespuestas" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Respuestas del restaurante</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table
              :headers="headersRest"
              :items="respuestasRestauranteComputed"
              :search="search"
            />
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogoRespuestas = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment-timezone";
export default {
  data() {
    return {
      dialogoRespuestas: false,
      search: "",
      loading: false,
      not: {
        titulo: "",
        cadencia: "",
        hora: "",
        respuestas: [],
      },
      headers: [
        {
          sortable: false,
          text: "Nombre restaurante",
          value: "nombre",
          width: "40%",
        },
        {
          sortable: false,
          text: "Ultima respuesta",
          value: "last",
          width: "40%",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          width: "10%",
          align: "right",
        },
      ],
      headersRest: [
        {
          sortable: false,
          text: "Fecha lanzamiento",
          value: "fechaLanz",
          width: "30%",
        },
        {
          sortable: false,
          text: "Fecha contestada",
          value: "fechaContestada",
          width: "30%",
        },
        {
          sortable: false,
          text: "Respuesta",
          value: "respuesta",
          width: "40%",
        },
      ],
      respuestasRestaurante: [],
    };
  },
  computed: {
    respuestasTable() {
      return this.not.respuestas.map((r) => {
        let f = this.$store.state.restaurantes.restaurantesArray.find(
          (a) => a.id == r.id
        );
        var contestados = r.entregas.filter(
          (res) => res.estado == "contestado"
        );
        var last =
          contestados.length > 0 ? contestados[contestados.length - 1] : null;
        return {
          nombre: f ? f.nombre : r.id,
          last: last ? last.respuesta : "sin contestar",
          entregas: r.entregas,
        };
      });
    },
    respuestasRestauranteComputed() {
      return this.respuestasRestaurante.map((e) => {
        return {
          fechaLanz: moment.unix(e.lanzamiento).format("DD-MM-YYYY HH:mm"),
          fechaContestada: e.respuesta
            ? moment(e.fechaContestada.toDate()).format("DD-MM-YYYY HH:mm")
            : "-",
          respuesta: e.respuesta ? e.respuesta : "-",
        };
      });
    },
  },
  methods: {
    verRespuestasRestaurante(item) {
      this.dialogoRespuestas = true;
      console.log(item);
      this.respuestasRestaurante = item.entregas;
      console.log(this.respuestasRestaurante);
    },
  },
  async mounted() {
    this.id = this.$route.params.id_not ? this.$route.params.id_not : null;
    if (this.id) {
      let not = await this.$store.dispatch(
        "notificaciones/getNotificacion",
        this.id
      );
      this.not = not;
      console.log(this.not);
    }
  },
};
</script>